<template>
  <div id="calendar-id" class="calendar" style="overflow: scroll;">
    <!-- <div
      style="display: flex;  flex-direction: column;  align-items: center;  justify-content: center;  "
    >
      <select
        id="timezone"
        v-model="currentTimeZone"
        @change="handleTimeZoneChange"
      >
        <option v-for="zone in usaTimeZones" :value="zone" :key="zone">{{
          zone
        }}</option>
      </select>
    </div> 
  
   :time-zone="this.currentTimeZone" 
  -->
    <FullCalendar
      v-if="!this.showEvents"
      :key="this.calendarKey"
      :options="calendarOptions"
      :ref="this.calendarRef"
    />
    <div v-if="this.showEvents">
      <h2 class="text-right" ref="sbodScroll">
        <button
          type="button"
          class="bg-green-300 rounded-full font-semibold py-2 mt-4 mb-4 mr-4 text-center px-4"
          @click="showCal"
        >
          Close
        </button>
        <div class="form-group">
          <input type="radio" name="filterDay" v-model="filterDay" value="1" />
          All
          <input type="radio" name="filterDay" v-model="filterDay" value="0" />
          {{ this.showEventsDate }}
        </div>
      </h2>
      <table id="" class="border-collapse w-full text-sm">
        <thead>
          <tr>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Event Date
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              TM Link
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              TP Link
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Venue Name
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Notes
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Password
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Venue Capacity
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Currency
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Min
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Max
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Ticket Limit
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Sales
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Attractions
            </th>
            <th
              class="p-3 font-bold bg-gray-200 text-gray-600 border border-gray-300 hidden md:table-cell"
            >
              Seat Map
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-if="!priceRange"
            class="bg-white lg:hover:bg-gray-100 flex lg:table-row flex-row lg:flex-row flex-wrap lg:flex-no-wrap mb-10 lg:mb-0"
          >
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
              colspan="5"
            >
              Please wait...
            </td>
          </tr>
          <tr
            v-for="(item, i) in filteredDay"
            :key="i"
            class="bg-white lg:hover:bg-gray-100 flex lg:table-row flex-row lg:flex-row flex-wrap lg:flex-no-wrap mb-10 lg:mb-0"
          >
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              {{ item.date }}
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              <a
                class="cursor-pointer text-blue-600"
                :href="item.url"
                target="_blank"
                ><img
                  src="https://spaceseats.io/img/ticket.9586a5df.jpeg"
                  alt="img"
                  style="max-width: 30px;"
              /></a>
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              <a
                class="cursor-pointer text-blue-600"
                :href="'https://www.tickpick.com/search?q=' + item.ename"
                target="_blank"
                ><img
                  src="@/assets/img/landing/tickpick.png"
                  alt="img"
                  style="max-width: 30px;"
              /></a>
            </td>
            <td
              class="p-3 text-gray-800 border border-b block md:table-cell relative lg:static"
              style="width: 15%"
            >
              {{ item.vname }}
            </td>

            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              <p v-if="item.isNotesEditing"></p>
              <p v-if="!item.isNotesEditing">{{ item.notes }}</p>
              <div v-else-if="item.isNotesEditing">
                <textarea
                  placeholder="type your notes here"
                  v-model="notesInput"
                  class="input-styling"
                  rows="4"
                  cols="40"
                >
                </textarea>
              </div>
              <button
                class="text-green-600"
                @click="editNotes(i)"
                v-if="!item.isNotesEditing"
              >
                Edit
              </button>
              <button
                class="text-green-600"
                @click="saveNotes(i)"
                v-else-if="item.isNotesEditing"
              >
                Save
              </button>
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              <p v-if="item.isPasswordEditing"></p>
              <p v-if="!item.isPasswordEditing">{{ item.password }}</p>
              <div v-else-if="item.isPasswordEditing">
                <input
                  placeholder="type your notes here"
                  v-model="passwordInput"
                  class="input-styling"
                />
              </div>
              <button
                class="text-green-600"
                @click="editPassword(i)"
                v-if="!item.isPasswordEditing"
              >
                Edit
              </button>
              <button
                class="text-green-600"
                @click="savePassword(i)"
                v-else-if="item.isPasswordEditing"
              >
                Save
              </button>
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              <div
                style="cursor: pointer"
                class="text-green-800"
                :id="'vid' + i"
              >
                <div @click="getCapacity('vid' + i, item.vname + ' Capacity')">
                  Fetch
                </div>
              </div>
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              {{ item.currency }}
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              {{ item.min }}
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              {{ item.max }}
            </td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 border border-b block md:table-cell relative lg:static"
            >
              {{ item.tl }}
            </td>
            <td
              class="p-3 text-gray-800 border border-b block md:table-cell relative lg:static"
            >
              <p><b>Public:</b></p>
              <p>&nbsp;Start: {{ item.salesPuStart }}</p>
              <p><b>Presales:</b></p>
              <div v-if="item.presales">
                <div v-for="(p, i) in item.presales" :key="i">
                  <u>&nbsp;{{ p.name }}:</u>
                  <p>&nbsp;&nbsp;Start: {{ p.start }}</p>
                </div>
              </div>
            </td>
            <td
              class="p-3 text-gray-800 border border-b block md:table-cell relative lg:static"
            >
              <div
                v-for="(a, i) in item.attractions"
                :key="i"
                :id="'keywordTextDiv' + i"
              >
                <p>&nbsp;{{ a.name }}</p>
              </div>

              <div
                style="cursor: pointer"
                x-data="{ item.pop: false }"
                class="text-green-800 relative"
                type="button"
                @click="
                  item.pop = !item.pop;
                  getKeywordStatsModal(
                    // 'keywordsStatsInner' + i,
                    i,
                    item.attractions
                  );
                "
              >
                Fetch Stats
                <!-- {{ item.pop ? "Open" : "Closed" }} -->
              </div>
              <!-- class="absolute left-1/2 mt-4 w-100 top-20 bg-white rounded-md overflow-hidden shadow-xl z-10" -->

              <div
                class="overflow-y-auto overflow-x-hidden mx-auto my-auto w-50 h-50 bg-white fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] shadow-2xl max-h-full bg-gray-800 bg-opacity-50"
                :id="'keywordsStatsInner' + i"
                v-show="item.pop"
                x-transition:enter="transition ease-out duration-100 transform"
                x-transition:enter-start="opacity-0 scale-95"
                x-transition:enter-end="opacity-100 scale-100"
                x-transition:leave="transition ease-in duration-75 transform"
              >
                <div
                  class="relative text-center w-100 font-bold px-3 py-10 bg-gray-100 bg-opacity-50 flex justify-center items-center "
                  :id="'stats-modal-header' + i"
                >
                  <h2 class="text-2xl">Keyword Statistics from Google</h2>

                  <button
                    class="absolute bg-green-300 rounded-full font-semibold py-2 right-2 text-center px-4"
                    @click="item.pop = false"
                    :id="'close-modal' + i"
                  >
                    Close
                  </button>
                </div>
                <div
                  class="relative px-10 my-10 "
                  :id="'stats-modal-content' + i"
                >
                  <p class="text-green-300">
                    Fetching the data may take 5-10 seconds ....
                  </p>
                </div>
              </div>
            </td>

            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border border-b block md:table-cell relative lg:static"
            >
              <img
                :src="item.seatmap"
                @click="showImage(item.seatmap)"
                width="150px"
              />
            </td>
          </tr>
        </tbody>

        <!-- boundary="app"
          sanitize="false"
          html="true"
          boundaryPadding="5"
          delay="500"
          offset="0" -->
      </table>
    </div>

    <!-- Radhika - change  -->
    <!-- <div id="bpopover-container"> -->
    <!-- <div>
        <b-button id="popover-reactive-1">Click Test</b-button>
      </div> -->

    <!--:id="'popover' + i" -->
    <!-- :show.sync="popoverShow" -->
    <!-- @show="onShow"
        @shown="onShown"
        @hidden="onHidden" -->

    <!-- </div> -->
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridWeek from "@fullcalendar/timegrid";
import multiMonth from "@fullcalendar/multimonth";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
// import moment from "moment-timezone";
import "viewerjs/dist/viewer.css";
import axios from "axios";
import { BPopover } from "bootstrap-vue";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";

Vue.use(BootstrapVue);

//Radhika - change
// import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Import Bootstrap and BootstrapVue CSS files (order is important)
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  name: "Calendar",
  components: {
    FullCalendar,
  },
  data() {
    return {
      showEvents: false,
      calendarKey: 0,
      calendarRef: "myCalendar",
      showEventsDate: "",
      filterDay: "0",
      notesInput: "",
      passwordInput: "",
      currentEventId: "",
      events: [],
      priceRange: [],
      comma_seperated_keywords: [],
      //Radhika - change
      content_new: "",
      // target_name: null,
      // content_desc: null,
      // showPopover: false,
      eData: {},
    };
  },
  computed: {
    filteredDay() {
      let th = this;
      if (this.filterDay == "1") {
        return this.priceRange;
      } else {
        return this.priceRange.filter(function(pr) {
          let check = false;
          for (let j = 0; j < pr.presales.length; j++) {
            if (th.showEventsDate === pr.presales[j].start) check = true;
          }
          return check;
        });
      }
    },
    calendarOptions() {
      return {
        plugins: [
          momentTimezonePlugin,
          dayGridPlugin,
          timeGridWeek,
          multiMonth,
        ],
        timeZone: "UTC",
        headerToolbar: {
          left: "dayGridMonth,timeGridWeek,timeGridDay",
          center: "title",
          right: "today prev,next",
        },
        initialView: "dayGridMonth",
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        // eventRender: function(info) {
        //   // if (info.event.extendedProps.thumb) {
        //     info.el.firstChild.innerHTML =
        //       info.el.firstChild.innerHTML +
        //       "<img src='https://spaceseats.io/img/ticket.9586a5df.jpeg' width='40' height='40'>";
        //   // }
        // },
        eventDidMount: function(info) {
          console.log(info.event);
          this.content_new = (
            <div>
              <p style="font-size: 15px;">
                {info.event.extendedProps.description}
              </p>
              <br />
              <div>
                <a target="_blank" href={info.event.extendedProps.tlink}>
                  <img
                    src="https://spaceseats.io/img/ticket.9586a5df.jpeg"
                    alt="img"
                    style="max-width: 30px;"
                  ></img>
                </a>

                {/* <a class="mx-2" href={info.event.extendedProps.tlink}>
                  <img
                    src="data:image/png;base64,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"
                    alt="img"
                    style="max-width: 30px;"
                  ></img>
                </a> */}
              </div>
            </div>
          );
          new BPopover({
            propsData: {
              target: info.el,
              title: "Information",
              boundary: "app",
              // content: info.event.extendedProps.description,
              //Radhika - change
              content: this.content_new,
              sanitize: false,
              triggers: "hover",
              placement: "auto",
              html: true,
              boundaryPadding: 5,
              delay: 500,
              offset: 0,
            },
          }).$mount();
        },

        //Radhika - change

        // eventDidMount: function(info) {
        //   console.log("info mounted");
        //   console.log(info.el);

        //   this.showPopover = true;
        //   console.log(this.showPopover);
        //   info.el.setAttribute("variant", "default");
        //   // info.el.setAttribute("ref", "popover_ref");
        //   info.el.setAttribute("v-if", "showPopover");
        //   var random_id = info.event.id;
        //   info.el.setAttribute("id", "my_popover_id" + random_id);
        //   this.content_desc = info.event.extendedProps.description;
        //   // <b-link href="https://google.com">
        //   // {info.event.extendedProps.description;}
        //   // </b-link>
        //   this.target_name = info.el.id;

        //   // this.$refs.popover.target = info.el.id;
        //   // this.$refs.popover.content = info.event.extendedProps.description;

        //   console.log(this.target_name);
        //   console.log(this.content_desc);
        //   // this.content =
        //   //   // <b-link href="https://google.com">
        //   //   info.event.extendedProps.thumb;
        //   // </b-link>
        // },

        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        // eventContent: function(info) {
        //   return { html: info.event.title };
        // },
        events: this.events,
        // eventRender: this.customizeEventRendering
        // eventRender: function(event) {
        //   event.el.firstChild.innerHTML = "<div><h4><a href='#'>"+ event.event.title +"</a></h4><img src='https://spaceseats.io/img/ticket.9586a5df.jpeg' width='40' height='40'></div>";
        // }
      };
    },
  },
  methods: {
    // handleTimeZoneChange() {
    //   // Update FullCalendar's time zone when the user changes the selection+
    //   console.log("Selected Time Zone:", this.currentTimeZone);
    //   // Update Moment Timezone
    //   moment.tz.setDefault(this.currentTimeZone);
    //   // Force FullCalendar to refetch events
    //   this.$refs.myCalendar.getApi().refetchEvents();

    //   // Save the selected time zone to localStorage
    //   localStorage.setItem("selectedTimeZone", this.currentTimeZone);
    //   // Update FullCalendar
    //   // FullCalendar.setOptions({
    //   //   timeZone: this.currentTimeZone
    //   // });
    //   // You can perform additional actions here if needed
    // },
    addStringBeforeSpecific(pos, originalString, newString) {
      // Escape special characters in the specific string
      let originalText = originalString;
      let comingText = newString;

      // Split the original text into an array of substrings
      let originalArray = originalText.split(", ");

      // Insert the coming text before the price at the appropriate position
      originalArray.splice(pos, 0, comingText);

      // Join the array back into a string
      let resultText = originalArray.join(", ");

      return resultText;
    },
    fetchEvents() {
      axios
        .get("https://cheetahseats.com/api/calendar_new")
        .then((response) => {
          var thi = [];
          // console.log(response);
          // var filteredFav = response.data.data.filter(
          //   item => item.type === "favourite"
          // );
          for (let i = 0; i < response.data.data.length; i++) {
            let title = this.addStringBeforeSpecific(
              4,
              response.data.data[i].event_name,
              response.data.data[i].sale_type
            );

            // var eDateFilter = filteredFav.filter(
            //   item => item.fav_id === response.data.data[i].fav_id
            // );

            // console.log(eDateFilter);
            // let title = this.addStringBeforeSpecific(
            //   5,
            //   btitle,
            //   eDateFilter[0].type
            // );

            thi.push({
              title: title,
              description: title,
              tlink: response.data.data[i].tmurl,

              start:
                response.data.data[i].edate != ""
                  ? response.data.data[i].edate
                  : response.data.data[i].date.replaceAll("/", "-"),
              id: response.data.data[i].fav_id,
              groupId: response.data.data[i].fav_id,
              data: response.data.data[i].events,
              thumb: "https://spaceseats.io/img/ticket.9586a5df.jpeg",
              // timeZone: response.data.data[i].timezone,
              color: response.data.data[i].fav_type,
              textColor:
                response.data.data[i].fav_type == "yellow" ? "black" : "white",
            });
          }
          // thi.push({
          //   title:
          //     "Test 11  Test 12 Test 13 Test 14 Test 15 Test 16 Test 17 Test 18 Test 19 Test 20",
          //   start: "2023-11-26T09:00:00Z"
          // });

          // console.log(thi);
          this.events = this.filterUniqueArray(thi);
          this.calendarKey = this.events.length;
          // this.$refs.calendarRef.$emit("eventsChanged");
          // console.log("this.events");
          // console.log(this.events);
          // var result = [];
          // thi.forEach(function(item) {
          //   if (result.indexOf(item) < 0) {
          //     result.push(item);
          //   }
          // });
          // this.events = result;

          // console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    customizeEventRendering(info) {
      // Customize the event rendering here
      info.el.style.backgroundColor = info.event.extendedProps.color; // Set the background color
      info.el.style.borderColor = info.event.extendedProps.color; // Set the border color
    },
    filterUniqueArray(arr) {
      const uniqueItems = []; // Create a new array for the unique objects
      const seen = new Set(); // Create a Set to store unique combinations of title and type

      for (const item of arr) {
        const key = `${item.title}-${item.start}`; // Create a unique key based on title and type

        if (!seen.has(key)) {
          // If the key is not in the Set, it's unique
          seen.add(key);
          uniqueItems.push(item);
        }
      }

      return uniqueItems;
    },
    editNotes(i) {
      this.priceRange[i].isNotesEditing = !this.priceRange[i].isNotesEditing;
      this.notesInput = this.priceRange[i].notes;
    },
    saveNotes(i) {
      this.priceRange[i].notes = this.notesInput;
      this.priceRange[i].isNotesEditing = !this.priceRange[i].isNotesEditing;
      var foundIndex = this.eData.findIndex(
        (x) => x.id == this.priceRange[i].id
      );
      this.eData[foundIndex].notes = this.priceRange[i].notes;
      axios
        .post(`https://cheetahseats.com/api/updatefavourite_events_new`, {
          fav_id: this.currentEventId,
          events: this.eData,
          title: "Notes",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Methods":
              "GET, POST, PATCH, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, X-Auth-Token",
          },
        })
        .then((result) => {
          alert(result.data.message);
        })
        .catch((error) => console.log("error", error));
    },
    editPassword(i) {
      this.priceRange[i].isPasswordEditing = !this.priceRange[i]
        .isPasswordEditing;
      this.passwordInput = this.priceRange[i].password;
    },
    savePassword(i) {
      this.priceRange[i].password = this.passwordInput;
      this.priceRange[i].isPasswordEditing = !this.priceRange[i]
        .isPasswordEditing;
      var foundIndex = this.eData.findIndex(
        (x) => x.id == this.priceRange[i].id
      );
      this.eData[foundIndex].password = this.priceRange[i].password;
      axios
        .post(`https://cheetahseats.com/api/updatefavourite_events_new`, {
          fav_id: this.currentEventId,
          events: this.eData,
          title: "Password",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Methods":
              "GET, POST, PATCH, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, X-Auth-Token",
          },
        })
        .then((result) => {
          alert(result.data.message);
        })
        .catch((error) => console.log("error", error));
    },
    showCal() {
      this.showEvents = false;
    },
    handleEventClick(clickInfo) {
      // let obj = this.events.find(o => o.id == clickInfo.event.id);
      this.showEventsDate = new Date(clickInfo.event.start).toLocaleString(
        "en-US",
        {
          timeZone: "UTC",
        }
      );

      console.log(clickInfo.event.id);
      this.priceRange = [];
      if (clickInfo.event.id) {
        this.currentEventId = clickInfo.event.id;
        axios
          .get(
            "https://cheetahseats.com/api/getfavourite_events_new?eid=" +
              clickInfo.event.id
          )
          .then((response) => {
            console.log(response);
            this.eData = JSON.parse(response.data.data.events);

            console.log(this.eData);
            for (let j = 0; j < this.eData.length; j++) {
              if (this.eData[j].priceRanges && this.eData[j]._embedded) {
                // console.log(this.eData[j].id);

                let tlim = "N/A";
                if (this.eData[j].ticketLimit)
                  tlim = this.eData[j].ticketLimit.info;
                let smap = "https://spaceseats.io/img/notfound.png";
                if (this.eData[j].seatmap)
                  smap = this.eData[j].seatmap.staticUrl;

                let preSales = [];

                let attractionsData = [];

                if (this.eData[j].sales.presales) {
                  for (
                    let p = 0;
                    p < this.eData[j].sales.presales.length;
                    p++
                  ) {
                    preSales.push({
                      name: this.eData[j].sales.presales[p].name,
                      start: new Date(
                        this.eData[j].sales.presales[p].startDateTime
                      ).toLocaleString("en-US", {
                        timeZone: "UTC",
                      }),
                    });
                  }
                }
                if (this.eData[j]._embedded.attractions) {
                  for (
                    let a = 0;
                    a < this.eData[j]._embedded.attractions.length;
                    a++
                  ) {
                    attractionsData.push({
                      name: this.eData[j]._embedded.attractions[a].name,
                      // pop: false,
                    });
                  }
                }

                this.priceRange.push({
                  date: new Date(
                    this.eData[j].dates.start.localDate
                  ).toLocaleString("en-US", { timeZone: "UTC" }),
                  vname: this.eData[j]._embedded.venues[0].name,
                  ename: this.eData[j].name,
                  url: this.eData[j].url,
                  currency: this.eData[j].priceRanges[0].currency,
                  min: this.eData[j].priceRanges[0].min,
                  max: this.eData[j].priceRanges[0].max,
                  tl: tlim,
                  salesPuStart: new Date(
                    this.eData[j].sales.public.startDateTime
                  ).toLocaleString("en-US", { timeZone: "UTC" }),
                  presales: preSales,
                  attractions: attractionsData,
                  pop: false,
                  notes:
                    this.eData[j].notes ??
                    "Price Range: " +
                      this.eData[j].priceRanges[0].min +
                      " - " +
                      this.eData[j].priceRanges[0].max +
                      " \nTicket Limit: " +
                      tlim +
                      " \nLink: " +
                      this.eData[j].url +
                      "\n \n",
                  password: this.eData[j].password ?? "Password",
                  isNotesEditing: false,
                  isPasswordEditing: false,
                  seatmap: smap,
                  id: this.eData[j].id,
                });
              }
            }
            // console.log(response);
          })
          .catch((error) => {
            console.log(error);
          });
      }
      /*
      // const result = this.events.find(({ id }) => id === clickInfo.event.id);
      this.currentEventId = clickInfo.event.id;
      let obj = this.events.find(o => o.id == clickInfo.event.id);

*/
      this.showEvents = true;
      // console.log(clickInfo.event.start);
      this.currentEventName = clickInfo.event.name;
      // console.log(JSON.parse(obj.data));
      // this.priceRange.push()
      // setTimeout(function() {
      //   this.$refs.edScroll?.scrollIntoView({ behavior: "smooth" });
      // }, 1000);
      // if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
      //   clickInfo.event.remove()
      // }
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    ContainsAny(str, items) {
      for (var i in items) {
        var item = items[i];
        if (str.indexOf(item) > -1) {
          return true;
        }
      }
      return false;
    },
    getCapacity(vid, qury) {
      document.getElementById(vid).innerHTML = "Fetching...";

      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `https://en.wikipedia.org/w/api.php?action=query&list=search&prop=info&inprop=url&utf8=&format=json&origin=*&srsearch=${qury}`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          result = JSON.parse(result);
          let eCheck = false;
          // var html = "<html>" + result.query?.search[0]?.snippet + "</html>";
          var html = "<html>";

          result.query?.search.forEach((element) => {
            if (
              this.ContainsAny(element.snippet, [
                "seat",
                "seats",
                "capacity",
                "seating",
              ])
            ) {
              html += element.snippet;
              eCheck = true;
            }
          });
          html += "</html>";
          if (eCheck) {
            document.getElementById(vid).innerHTML = html;
          } else {
            document.getElementById(vid).innerHTML =
              "<html> Not Found! </html>";
          }
        })
        .catch((error) => (document.getElementById(vid).innerHTML = error));
    },
    getKeywordStats(keywordTextDivi, vid, keywords_array) {
      // console.log(keywords_array[0].name);
      //console.log(keywords_array.length);

      for (var i = 0; i < keywords_array.length; i++) {
        this.comma_seperated_keywords.push(keywords_array[i].name);
      }
      console.log(this.comma_seperated_keywords);

      document.getElementById(vid).innerHTML = "Fetching...";
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };
      fetch(
        `https://cheetahseats.com/spaceseat/gads/get_ads.php?keywords=${this.comma_seperated_keywords}`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          // console.log(result);
          document.getElementById(keywordTextDivi).innerHTML = result;
          document.getElementById(vid).innerHTML = "Fetch Stats";
        });
    },
    getKeywordStatsModal(k, keywords_array) {
      // console.log(keywords_array[0].name);
      //console.log(keywords_array.length);

      for (var i = 0; i < keywords_array.length; i++) {
        this.comma_seperated_keywords.push(keywords_array[i].name);
      }
      console.log(this.comma_seperated_keywords);

      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };
      fetch(
        `https://cheetahseats.com/spaceseat/gads/get_ads.php?keywords=${this.comma_seperated_keywords}`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          // console.log(result);
          document.getElementById("stats-modal-content" + k).innerHTML = result;
          // document.getElementById("stats-modal-close" + k).className =
          // "visible text-center bg-gray-100 bg-opacity-50 sticky bottom-0";
        });
    },
    showImage(url) {
      this.$viewerApi({
        images: [url],
      });
    },
  },
  mounted() {
    // const storedTimeZone = localStorage.getItem("selectedTimeZone");
    // if (storedTimeZone && this.usaTimeZones.includes(storedTimeZone)) {
    //   this.currentTimeZone = storedTimeZone;
    // }
    this.fetchEvents(); // fetch events on component mount
  },
};
</script>
